import Header from "./HeaderPage"
import Menus from "./Menus"
import Contact from "./Contact"
export { Header, Menus, Contact }
export default Header
